import { supportContractApi } from "@/core/apis";

// getter types
export const SUPPORT_CONTRACTS = "supportContracts";

// action types
export const GET_SUPPORT_CONTRACTS = "getSupportContracts";

// mutation types
const SET_SUPPORT_CONTRACTS = "setSupportContracts";

const state = {
  supportContracts: []
};

const getters = {
  [SUPPORT_CONTRACTS](state) {
    return state.supportContracts;
  }
};

const actions = {
  [GET_SUPPORT_CONTRACTS](context) {
    return new Promise(resolve => {
      supportContractApi.getInfoSupportContract().then(response => {
        context.commit(SET_SUPPORT_CONTRACTS, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_SUPPORT_CONTRACTS](state, supportContracts) {
    state.supportContracts = supportContracts;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
